declare namespace $ {

	export class $shm_hitalama_version_label extends $mol_view {
		title( ): string
		version( ): string
		date( ): string
		available_version( ): string
		outdated( ): boolean
		sub( ): readonly(any)[]
		attr( ): ({ 
			'outdated': ReturnType< $shm_hitalama_version_label['outdated'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=label.view.tree.d.ts.map